// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltipOnboarding_tooltip__cSxjD","fadeInAndOut":"TooltipOnboarding_fadeInAndOut__YsXik","button":"TooltipOnboarding_button__b9sWc"};